const mediaItems = [
  {
    title: '台北娜娜独家专访片段',
    desc: '面对近期争议，台北娜娜首次正面回应，透露不为人知的心路历程',
    duration: '15:42',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20photography%20with%20soft%20dramatic%20lighting%2C%20crimson%20and%20amber%20tones%2C%20abstract%20composition%20evoking%20celebrity%20interview%20aesthetic%2C%20modern%20Chinese%20media%20style%2C%20rich%20textures%2C%20no%20text%20no%20faces%20no%20people&width=700&height=460&seq=media-01-interview&orientation=landscape',
  },
  {
    title: '莫里秀直播事件完整回放',
    desc: '从直播片段到后续发酵，完整还原莫里秀事件的每一个关键节点',
    duration: '22:08',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20editorial%20photography%20with%20deep%20burgundy%20and%20charcoal%20tones%2C%20cinematic%20atmosphere%2C%20abstract%20composition%20suggesting%20controversy%20and%20drama%2C%20modern%20Chinese%20digital%20media%20aesthetic%2C%20no%20text%20no%20faces%20no%20people&width=700&height=460&seq=media-02-replay&orientation=landscape',
  },
  {
    title: '玩偶姐姐幕后团队大揭秘',
    desc: '51吃瓜大赛独家调查：玩偶姐姐背后的商业运作全链条深度解析',
    duration: '18:35',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20editorial%20photography%20with%20crimson%20and%20gold%20highlights%2C%20abstract%20geometric%20composition%2C%20investigative%20journalism%20aesthetic%2C%20modern%20Chinese%20media%20style%2C%20luxurious%20dark%20textures%2C%20no%20text%20no%20faces%20no%20people&width=700&height=460&seq=media-03-investigation&orientation=landscape',
  },
  {
    title: '2026上半年吃瓜名场面',
    desc: '盘点上半年那些让人目瞪口呆的吃瓜瞬间，每一帧都是经典',
    duration: '31:20',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20warm%20editorial%20photography%20with%20rich%20crimson%20and%20golden%20accents%2C%20cinematic%20highlight%20compilation%20aesthetic%2C%20modern%20Chinese%20entertainment%20media%20style%2C%20dynamic%20atmosphere%2C%20no%20text%20no%20faces%20no%20people&width=700&height=460&seq=media-04-highlights&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            吃瓜现场
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精彩视频内容呈现，带你沉浸式体验吃瓜第一现场
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-200 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}